import React, { useContext } from 'react';
import { useIonRouter } from '@ionic/react';
import ChatbotButton from 'components/chatbot/ChatbotButton';
import ChatbotWindow from 'components/chatbot/ChatbotWindow';
import ChatbotSidebar from 'components/chatbot/ChatbotSidebar';
import { UserContext, UserContextProps } from 'contexts/UserContext';
import 'components/chatbot/Chatbot.scss';
import { ElearningContext, ElearningContextProps } from 'contexts/ElearningContext';
import { VideoPlayerContext, VideoPlayerContextProps } from 'contexts/VideoPlayerContext';
import { ROUTES } from 'constants/routes';

const Chatbot: React.FC = () => {
    const { user } = useContext(UserContext) as UserContextProps;
    const { elearningFrameUrl } = useContext(ElearningContext) as ElearningContextProps;
    const { videoUrl } = useContext(VideoPlayerContext) as VideoPlayerContextProps;
    // Ionic's routeInfo rather than react-router's useLocation(): with history v5
    // the Router keeps a { location, action } payload after the first navigation,
    // so location.pathname is empty outside the IonRouterOutlet (see PrivateRoute).
    const { routeInfo } = useIonRouter();

    // The chatbot button (z-index 999) would float over full-screen content:
    // the LMS overlay, the digital-training iframe page (quizzes and their
    // feedback) and the video player. Keep it out of those screens.
    const isFullScreenContentOpen =
        !!elearningFrameUrl || !!videoUrl || routeInfo?.pathname === ROUTES.TRAINING;

    // Only show chatbot to users whose chatbot switch is enabled (back-office)
    if (
        !user?.profileInfo?.chatbotEnabled ||
        isFullScreenContentOpen
    ) {
        return null;
    }

    return (
        <div className="chatbot-container">
            <ChatbotButton />
            <ChatbotWindow />
            <ChatbotSidebar />
        </div>
    );
};

export default Chatbot;
